module.exports = __webpack_public_path__ + "img/small-pump-up.4e6e6f28.png";